/** Query key for lightweight “where did we open this event from?” context. */
export const EVENT_NAV_FROM_PARAM = "from" as const

export type EventNavFrom = "events" | "attending" | "timeline"

const FALLBACK_PATH: Record<EventNavFrom, string> = {
  events: "/events",
  /** Unified Events hub — avoids an extra redirect from legacy `/attending`. */
  attending: "/events?segment=attending",
  timeline: "/timeline",
}

const LABEL: Record<EventNavFrom, string> = {
  events: "Back to events",
  attending: "Back to events",
  timeline: "Back to archive",
}

export function parseEventNavFrom(
  raw: string | null | undefined,
): EventNavFrom | null {
  const v = raw?.trim().toLowerCase() ?? ""
  if (v === "events" || v === "attending" || v === "timeline") return v
  return null
}

export function withEventNavFrom(path: string, from: EventNavFrom): string {
  const q = path.indexOf("?")
  const pathname = q >= 0 ? path.slice(0, q) : path
  const existing = q >= 0 ? path.slice(q + 1) : ""
  const params = new URLSearchParams(existing)
  params.set(EVENT_NAV_FROM_PARAM, from)
  return `${pathname}?${params.toString()}`
}

export function eventNavFallbackHref(from: EventNavFrom): string {
  return FALLBACK_PATH[from]
}

export function eventNavBackLabel(from: EventNavFrom): string {
  return LABEL[from]
}
